// extracted by mini-css-extract-plugin
export default {"card":"h2-z"};